import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { GasprecioService } from 'src/app/modules/gasprecio/services/gasprecio.service';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-week',
  templateUrl: './select-week.component.html',
  styleUrls: ['./select-week.component.scss']
})
export class SelectWeekComponent implements OnInit, OnDestroy {

  public items: any[] = [];
  public week: any = [];
  public weekSelected;
  public ngxDisabled = true;
  // Etiqueta OPCIONAL para la semana ACTUAL (items[1], ver getWeeksSchedule):
  // renombra solo el TEXTO visible de esa opción (p. ej. "Semana actual") sin
  // tocar su value — el value sigue siendo el nombre original del backend, que
  // es lo que viaja por SharedService y mantiene sincronizadas las demás
  // instancias/vistas. Pedida para los filtros sin título del flujo MOBICO
  // (task 2026-07-10): sin label arriba, la opción debe autoexplicar el filtro.
  @Input() currentWeekLabel?: string;
  week$: Subscription;
  weekSelected$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private gasprecioService: GasprecioService,
    private sharedService: SharedService
  ) {
    this.week$ = sharedService.sharedWeek.subscribe((week: string) => {
      if (week !== this.week) {
        this.week = week;
      }
    });

    this.weekSelected$ = this.sharedService.sharedWeekSelected.subscribe(weekSelected => {
      if (weekSelected !== this.weekSelected) {
        this.weekSelected = weekSelected;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit(): void {
    this.getWeeksSchedule();
  }

  ngOnDestroy() {
    this.week$.unsubscribe();
    this.weekSelected$.unsubscribe();
  }

  getWeeksSchedule() {
    this.gasprecioService.getWeeksSchedule().subscribe((data: any) => {
      const weeks: any = data;
      // El backend no garantiza el orden de las semanas: se ordenan acá de forma
      // determinista por fecha de inicio, DESCENDENTE (más reciente/futura primero).
      // Con ese orden, items[1] (segundo item, ver default más abajo) corresponde a
      // la semana ACTUAL — items[0] queda como la próxima semana. Defensivo: si a
      // algún item le faltara interval/start_date, no rompe el sort (va al final,
      // orden estable respecto al resto).
      const sortedWeeks = [...weeks].sort((a: any, b: any) => {
        const aTime = a?.interval?.start_date ? new Date(a.interval.start_date).getTime() : NaN;
        const bTime = b?.interval?.start_date ? new Date(b.interval.start_date).getTime() : NaN;
        if (isNaN(aTime) && isNaN(bTime)) { return 0; }
        if (isNaN(aTime)) { return 1; }
        if (isNaN(bTime)) { return -1; }
        return bTime - aTime;
      });
      sortedWeeks.forEach((element: any) => {
        this.items.push({ name: element['name'], value: element['name'], interval: element['interval'] });
      });
      // Solo el texto visible: el value queda intacto (ver comentario del @Input).
      if (this.currentWeekLabel && this.items[1]) {
        this.items[1]['name'] = this.currentWeekLabel;
      }
      if (this.week === '' || this.weekSelected === '') {
        this.week = [this.items[1]['value']];
        this.weekSelected = this.items[1]['interval'];
        this.sharedService.nextWeekSelected = this.weekSelected;
      }
      this.ngxDisabled = false;
    });
  }

  changeWeek(event: any) {
    this.week = event;
    this.items.forEach((element: any) => {
      // Match por value (no name): con currentWeekLabel el name visible de la
      // semana actual ya no coincide con lo que guarda el ngModel (el value).
      // Sin la etiqueta, value === name, así que el comportamiento es idéntico.
      if (element['value'] === this.week) {
        this.weekSelected = element['interval'];
        this.sharedService.nextWeekSelected = this.weekSelected;
      }
    });
    this.sharedService.nextWeek = this.week;
  }
}
